import { z } from 'zod';

const coordinateSchema = z.object({
  x: z.number().nullish().default(0),
  y: z.number().nullish().default(0)
});
const sizeSchema = z.object({
  width: z.number().nullish().default(1),
  height: z.number().nullish().default(1)
});
const fontSizeSchema = z.enum([
  "small",
  "medium",
  "large",
  "extra-large"
]);

export { coordinateSchema, fontSizeSchema, sizeSchema };
//# sourceMappingURL=Shared.js.map
